import { render, staticRenderFns } from "./SendRecord.vue?vue&type=template&id=5172c45d&scoped=true"
import script from "./SendRecord.vue?vue&type=script&lang=js"
export * from "./SendRecord.vue?vue&type=script&lang=js"
import style0 from "./SendRecord.vue?vue&type=style&index=0&id=5172c45d&prod&lang=scss&scoped=true"
import style1 from "./SendRecord.vue?vue&type=style&index=1&id=5172c45d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5172c45d",
  null
  
)

export default component.exports